<template>
  <v-menu
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn
            icon
            :small="small"
            v-on="{ ...onTooltip, ...on }"
          >
            <v-icon :small="small">
              mdi-chart-line
            </v-icon>
          </v-btn>
        </template>
        <span>Histórico de preço</span>
      </v-tooltip>
    </template>
    <v-card class="mx-auto"
            min-width="550"
            max-width="550">
      <v-card-text class="text--primary" v-if="opened">
        <px-historico-preco-produto :unidade-medida="unidadeMedida" :produto="produto" />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';

export default {
  mixins: [chartMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    unidadeMedida: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
};
</script>

<style scoped>

figure {
  max-width: 540px;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

figure .echarts {
  width: 550px;
  max-width: 550px;
}

</style>
